import { render, staticRenderFns } from "./NewExport.vue?vue&type=template&id=71724dd6&"
import script from "./NewExport.vue?vue&type=script&lang=js&"
export * from "./NewExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports